module.exports = __webpack_public_path__ + "img/new2.d2f0d4f9.png";